import { render, staticRenderFns } from "./messenger.vue?vue&type=template&id=1fe43c0a&functional=true"
var script = {}
import style0 from "./messenger.vue?vue&type=style&index=0&id=1fe43c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports